import { render, staticRenderFns } from "./ResourcesFolderCardHeader.vue?vue&type=template&id=32d840f8&scoped=true&"
import script from "./ResourcesFolderCardHeader.vue?vue&type=script&lang=js&"
export * from "./ResourcesFolderCardHeader.vue?vue&type=script&lang=js&"
import style0 from "./ResourcesFolderCardHeader.vue?vue&type=style&index=0&id=32d840f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d840f8",
  null
  
)

export default component.exports